import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppStateService } from '../services/app-state/app-state.service';

/**
 * Ensures the user is loaded into AppState and that the project list has been
 * fetched before activating any authenticated child route.
 */
export const userGuard: CanActivateFn = async () => {
  const appState = inject(AppStateService);

  if (appState.user() === undefined) {
    await appState.loadUser();
  }

  if (appState.projects().length === 0) {
    await appState.loadProjects();
  }

  return appState.user() !== undefined;
};
